import VideoConfButton from './VideoConfButton';

export default VideoConfButton;
